export default {
  SET_ALL_ROUTINGS(state, routings) {
      state.routings = routings;
  },

  SET_ROUTING(state, routing) {
    state.routing = routing;
  },

  ADD_ROUTE(state, route) {
    state.routing.routes.splice(state.routing.routes.length, 1, route)
  },

  UPDATE_ROUTE(state, { fields, index }) {
    if(Object.keys(fields).length === 0) {
        return
    }

    let copyRoute = { ...state.routing.routes[index] };
    // state.routing.routes[index] = { ...copyRoute, ...fields };
    state.routing.routes.splice(index, 1, { ...copyRoute, ...fields });
  },

  REMOVE_ROUTE(state, i) {
    state.routing.routes.splice(i, 1);
},
}
